import { IProduct } from 'reactApp/modules/products/products.types';
import { getPeriodName } from 'reactApp/utils/Period';

export const getPromoContent = (product: IProduct) => ({
    buttonText: `Получить ${product?.space.value}`,
    title: `+${product?.space.value} бесплатно`,
    text: `Получите ${product?.space.value} в Облаке бесплатно на ${getPeriodName(product?.trialPeriod || '', true)}`,
});
